import { formatDateTimezon } from "../../../common-data/Converts";

export const FutureSubscriptionButton = ({ row }) => (
  <button
    className="actionBtn icon no-icon-btn minWidth100"
    type="button"
    disabled
    style={{
      cursor: "not-allowed",
      padding: "10px 10px",
      border: "1px solid gray",
      color: "gray",
      textTransform: "capitalize",
      letterSpacing: "0.5px",
    }}>
    Subscription will start on
    <br />
    {row?.regular_start_date
      ? formatDateTimezon(row.regular_start_date)
      : "soon"}
  </button>
);
